import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from './ui/card';

const Visuals = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Contenido organizado por categorías
  const categories = {
    foto: [
      {
        id: 'foto-1',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-full-shot-of-a-27-year-old-man-with-fair-skin-an__56824.jpeg',
        type: 'image'
      },
      {
        id: 'foto-2',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-modern-urban-scene-at-night-filled-with-a-crowd-__56823.jpeg',
        type: 'image'
      },
      {
        id: 'foto-3',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-cinematic-nighttime-road-with-flickering-streetl__56822.jpeg',
        type: 'image'
      },
      {
        id: 'foto-4',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-photorealistic-editorialstyle-image-of-a-man-in-__56821.jpeg',
        type: 'image'
      },
      {
        id: 'foto-5',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-short-hair-man-wearing-dark-sunglasses-and-a-sle__56819.jpeg',
        type: 'image'
      },
      {
        id: 'foto-6',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-short-black-hair-man-wearing-dark-sunglasses-and__56818.jpeg',
        type: 'image'
      },
      {
        id: 'foto-7',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-short-black-hair-man-wearing-dark-sunglasses-and__56817.jpeg',
        type: 'image'
      },
      {
        id: 'foto-8',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-short-black-hair-man-wearing-dark-sunglasses-and__56816.jpeg',
        type: 'image'
      },
      {
        id: 'foto-9',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-portrait-of-short-hair-white-man-around-40-years__56815.png',
        type: 'image'
      },
      {
        id: 'foto-10',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-portrait-of-short-hair-white-man-around-40-years__56814.png',
        type: 'image'
      },
      {
        id: 'foto-11',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-portrait-of-short-hair-white-man-around-40-years__56813.png',
        type: 'image'
      },
      {
        id: 'foto-12',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-portrait-of-short-hair-white-man-around-40-years__56812.png',
        type: 'image'
      },
      {
        id: 'foto-13',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__a-cinematic-surreal-photo-of-a-man-skined-fit-mode__56810.png',
        type: 'image'
      },
      {
        id: 'foto-14',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/1.png',
        type: 'image'
      },
      {
        id: 'foto-15',
        title: '',
        description: '',
        imageUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/FP%20SESION%20DE%20FOTO%20EN%20SOLO1-2.png',
        type: 'image'
      }
    ],
    videos: [
      {
        id: 'video-tmh1',
        title: t('visuals.content.videos.takemyhand1.title'),
        description: t('visuals.content.videos.takemyhand1.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Take%20My%20Hand%2001.mp4',
        thumbnailUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Portada%20Cover%20Take%20My%20Hand%20Header%20Spotify-2.jpg',
        type: 'video'
      },
      {
        id: 'video-tmh2',
        title: t('visuals.content.videos.takemyhand2.title'),
        description: t('visuals.content.videos.takemyhand2.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Take%20my%20Hand%20post%202.mp4',
        thumbnailUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Portada%20Cover%20Take%20My%20Hand%20Header%20Spotify-2.jpg',
        type: 'video'
      },
      {
        id: 'video-1',
        title: t('visuals.content.videos.tunneloflight.title'),
        description: t('visuals.content.videos.tunneloflight.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Uplight%20post%2016%20de%20Diciembre.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1419242902214-272b3f66ee7a?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-2',
        title: t('visuals.content.videos.behind.title'),
        description: t('visuals.content.videos.behind.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/freepik__video-upscaler__67831.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-3',
        title: t('visuals.content.videos.hourglass.title'),
        description: t('visuals.content.videos.hourglass.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Relojes%20de%20Arena%20Desierto%20y%20Mar.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-4',
        title: t('visuals.content.videos.city.title'),
        description: t('visuals.content.videos.city.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Caminando%20en%20la%20CIudad%20%28%20pagina%20Web%29.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1514565131-fce0801e5785?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-5',
        title: t('visuals.content.videos.stars.title'),
        description: t('visuals.content.videos.stars.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/POST%2027%20DE%20JULIO%202025%20V1.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1446776877081-d282a0f896e2?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-6',
        title: t('visuals.content.videos.taking.title'),
        description: t('visuals.content.videos.taking.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Taking%20time.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-7',
        title: t('visuals.content.videos.floating.title'),
        description: t('visuals.content.videos.floating.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Post%2001%20de%20Agosto%20Floating%20In%20Times.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-8',
        title: t('visuals.content.videos.beforebreath.title'),
        description: t('visuals.content.videos.beforebreath.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Segundo%20post%20.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-9', 
        title: t('visuals.content.videos.iwokeup.title'),
        description: t('visuals.content.videos.iwokeup.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Segundo%20Post%20When%20I%20Wake.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-10',
        title: t('visuals.content.videos.inhiseyes.title'),
        description: t('visuals.content.videos.inhiseyes.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Segunda%20Version%20de%20Post%2020%20Agosto%20When%20%20i%20Wake.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1518834107812-67b0b7c58434?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-11',
        title: t('visuals.content.videos.afternoonmyself.title'),
        description: t('visuals.content.videos.afternoonmyself.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Post%2009%20de%20Marzo%20Aft%20with%20my%20self.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=500&fit=crop',
        type: 'video'
      },
      {
        id: 'video-12',
        title: t('visuals.content.videos.afternoonmyself2.title'),
        description: t('visuals.content.videos.afternoonmyself2.description'),
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Post%20Aft%20wiht%20my%20self%2006%20de%20marzo.mp4',
        thumbnailUrl: 'https://images.unsplash.com/photo-1475924156734-496f6cac893c?w=500&h=500&fit=crop',
        type: 'video'
      }
    ],
    lyrics: [
      {
        id: 'lyrics-1',
        title: 'Floating in Time',
        description: t('visuals.content.lyrics.floating.description'),
        youtubeId: 'I1GzGvQEjOU',
        type: 'youtube'
      },
      {
        id: 'lyrics-2',
        title: 'Odyssey',
        description: t('visuals.content.lyrics.odyssey.description'),
        youtubeId: 'SypjBmyTPIE',
        type: 'youtube'
      },
      {
        id: 'lyrics-3',
        title: 'It\'s Over',
        description: t('visuals.content.lyrics.itsover.description'),
        youtubeId: 'K9TULd9OMyE',
        type: 'youtube'
      }
    ],
    otros: [
      {
        id: 'otros-1',
        title: 'Finding my Shades',
        description: 'Visual narrative exploration',
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Shades%20personajes%201.mp4',
        type: 'video'
      },
      {
        id: 'otros-2',
        title: 'Leaving my shadows behind',
        description: 'Emotional journey in sound and vision',
        youtubeId: 'EdQMgSdVBFs',
        type: 'youtube'
      },
      {
        id: 'otros-3',
        title: 'Glow Above the Sea',
        description: 'Luminous reflections',
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Glow%20Above%20the%20Sea.mp4',
        type: 'video'
      },
      {
        id: 'otros-4',
        title: 'Just Fun',
        description: 'Playful moments captured',
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Patinando%20en%20la%20Odisea.mp4',
        type: 'video'
      },
      {
        id: 'otros-5',
        title: 'I can\'t hear your Voice',
        description: 'Silent conversations',
        videoUrl: 'https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/I%20cant%20hear%20your%20voice.mp4',
        type: 'video'
      }
    ]
  };

  return (
    <section id="visuals" className="py-24 px-6 bg-gradient-to-b from-black to-gray-900/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-light tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-white mb-8">
            {t('visuals.title')}
          </h2>
          <p className="text-xl text-gray-300 font-light max-w-2xl mx-auto">
            {t('visuals.subtitle')}
          </p>
        </div>

        {/* Videos Section - First */}
        <div className="mb-20">
          <h3 className="text-3xl font-light text-white mb-12 text-center tracking-wider">{t('visuals.categories.videos')}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8 max-w-7xl mx-auto">
            {categories.videos.map((item) => (
              <Card 
                key={item.id} 
                className="bg-black border-white/10 overflow-hidden hover:border-blue-400/30 transition-all duration-500 cursor-pointer group shadow-2xl"
                onClick={() => setSelectedVideo(item)}
              >
                <div className="relative bg-black h-[450px] overflow-hidden">
                  <video
                    src={item.videoUrl}
                    loop
                    muted
                    playsInline
                    className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                    <div className="bg-blue-500/20 backdrop-blur-md rounded-full p-6 border border-blue-400/30 group-hover:scale-110 transition-transform duration-300">
                      <svg className="w-12 h-12 text-blue-300" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 z-10">
                    <h4 className="text-white font-light text-lg mb-2 leading-tight">{item.title}</h4>
                    <p className="text-gray-200 text-sm leading-relaxed opacity-90">{item.description}</p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Foto Section */}
        <div className="mb-20">
          <h3 className="text-3xl font-light text-white mb-12 text-center tracking-wider">{t('visuals.categories.foto')}</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 max-w-7xl mx-auto">
            {categories.foto.map((item) => (
              <Card 
                key={item.id} 
                className="bg-black/20 border-white/10 overflow-hidden hover:border-blue-400/30 transition-all duration-500 cursor-pointer group"
                onClick={() => setSelectedImage(item)}
              >
                <div className="aspect-square relative overflow-hidden">
                  <img 
                    src={item.imageUrl} 
                    alt={`SYNTETIK Photo ${item.id}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Lyrics Section */}
        <div className="mb-20">
          <h3 className="text-3xl font-light text-white mb-12 text-center tracking-wider">{t('visuals.categories.lyrics')}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {categories.lyrics.map((item) => (
              <Card 
                key={item.id} 
                className="bg-black/20 border-white/10 overflow-hidden hover:border-blue-400/30 transition-all duration-500"
              >
                <div className="aspect-video bg-black">
                  <iframe
                    src={`https://www.youtube.com/embed/${item.youtubeId}?rel=0&modestbranding=1`}
                    title={item.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  />
                </div>
                <div className="p-6">
                  <h4 className="text-white font-light text-xl mb-3">{item.title}</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">{item.description}</p>
                </div>
              </Card>
            ))}
          </div>
        </div>

        {/* Otros Section */}
        <div className="mb-20">
          <h3 className="text-3xl font-light text-white mb-8 text-center tracking-wider">{t('visuals.categories.otros')}</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {categories.otros.map((item) => (
              <Card 
                key={item.id} 
                className="bg-black/20 border-white/10 overflow-hidden hover:border-blue-400/30 transition-all duration-500 cursor-pointer group"
                onClick={() => {
                  if (item.type === 'video') {
                    setSelectedVideo(item);
                  } else if (item.type === 'youtube') {
                    setSelectedImage(item);
                  }
                }}
              >
                {item.type === 'video' ? (
                  <div className="aspect-video relative overflow-hidden bg-black">
                    <video
                      src={item.videoUrl}
                      loop
                      muted
                      playsInline
                      className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <div className="bg-blue-500/20 backdrop-blur-md rounded-full p-4 border border-blue-400/30 group-hover:scale-110 transition-transform duration-300">
                        <svg className="w-8 h-8 text-blue-300" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                        </svg>
                      </div>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <h4 className="text-white font-light text-lg mb-2 leading-tight">{item.title}</h4>
                      <p className="text-gray-200 text-sm leading-relaxed opacity-90">{item.description}</p>
                    </div>
                  </div>
                ) : item.type === 'youtube' ? (
                  <div className="aspect-video bg-black relative">
                    <iframe
                      src={`https://www.youtube.com/embed/${item.youtubeId}?rel=0&modestbranding=1&showinfo=0&controls=1`}
                      title={item.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="w-full h-full"
                    />
                  </div>
                ) : (
                  <div className="aspect-square relative overflow-hidden">
                    <img 
                      src={item.imageUrl} 
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                      <h4 className="text-white font-light text-lg mb-1">{item.title}</h4>
                      <p className="text-gray-300 text-sm">{item.description}</p>
                    </div>
                  </div>
                )}
              </Card>
            ))}
          </div>
        </div>

        {/* Lightbox for Images and YouTube */}
        {selectedImage && selectedImage.type !== 'lyrics' && (
          <div 
            className="fixed inset-0 z-50 bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="max-w-4xl max-h-full relative">
              {selectedImage.type === 'youtube' ? (
                <div className="aspect-video bg-black rounded-lg overflow-hidden">
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedImage.youtubeId}?rel=0&modestbranding=1&autoplay=1`}
                    title={selectedImage.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              ) : (
                <img 
                  src={selectedImage.imageUrl} 
                  alt={`SYNTETIK ${selectedImage.id}`}
                  className="max-w-full max-h-full object-contain"
                />
              )}
              {selectedImage.title && selectedImage.description && (
                <div className="absolute -bottom-20 left-4 right-4 bg-black/70 backdrop-blur-sm p-4 rounded">
                  <h3 className="text-white font-light text-xl mb-2">{selectedImage.title}</h3>
                  <p className="text-gray-300">{selectedImage.description}</p>
                </div>
              )}
              <button 
                className="absolute -top-16 right-4 text-white hover:text-blue-300 transition-colors text-3xl bg-black/50 rounded-full w-12 h-12 flex items-center justify-center"
                onClick={() => setSelectedImage(null)}
              >
                ×
              </button>
            </div>
          </div>
        )}

        {/* Lightbox for Videos */}
        {selectedVideo && (
          <div 
            className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm flex items-center justify-center p-2 md:p-4"
            onClick={() => setSelectedVideo(null)}
          >
            <div className="max-w-5xl w-full max-h-full relative flex items-center justify-center">
              <div className="bg-black rounded-lg overflow-hidden shadow-2xl max-h-[90vh] flex items-center justify-center relative">
                <video
                  src={selectedVideo.videoUrl}
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls
                  controlsList="nodownload nofullscreen"
                  className="max-w-full max-h-full object-contain"
                  onClick={(e) => e.stopPropagation()}
                  style={{ maxHeight: '80vh' }}
                />
                
                {/* Audio notification */}
                <div className="absolute top-4 left-4 bg-black/80 backdrop-blur-md text-white text-xs md:text-sm px-3 py-2 rounded-full border border-white/20 pointer-events-none">
                  🔊 Click unmute for audio
                </div>
                
                {/* Custom controls overlay for better mobile visibility */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent h-20 md:h-16 pointer-events-none"></div>
              </div>
              
              {/* Video info - Better positioned for mobile */}
              <div className="absolute -bottom-16 md:-bottom-24 left-4 right-4 bg-black/80 backdrop-blur-md p-4 md:p-6 rounded-lg border border-white/10">
                <h3 className="text-white font-light text-lg md:text-2xl mb-1 md:mb-2">{selectedVideo.title}</h3>
                <p className="text-gray-300 text-sm md:text-lg">{selectedVideo.description}</p>
              </div>
              
              {/* Close button - Better positioned for mobile */}
              <button 
                className="absolute -top-12 md:-top-16 right-2 md:right-4 text-white hover:text-blue-300 transition-colors text-2xl md:text-4xl font-light bg-black/70 backdrop-blur-sm rounded-full w-10 h-10 md:w-12 md:h-12 flex items-center justify-center border border-white/20"
                onClick={() => setSelectedVideo(null)}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Visuals;